/* eslint-disable no-underscore-dangle */

const _ = require('lodash');

class ScheduleStatusRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('schedule-status-column');
    this._rootElem.component = this._model;

    this._pendingIcon = document.createElement('div');
    this._pendingIcon.classList.add(
      'glu-icon-button__icon',
      'g-icon',
      'glu-flex',
      'g-icon-pending'
    );
    this._pendingIcon.setAttribute('title', 'Active');

    this._pausedIcon = document.createElement('div');
    this._pausedIcon.classList.add('glu-icon-button__icon', 'g-icon', 'glu-flex', 'g-icon-paused');
    this._pausedIcon.setAttribute('title', 'Paused');

    this._completedIcon = document.createElement('div');
    this._completedIcon.classList.add(
      'glu-icon-button__icon',
      'g-icon',
      'glu-flex',
      'g-icon-completed'
    );
    this._completedIcon.setAttribute('title', 'Completed');

    this._registerListeners();
    this.render();
  }

  /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
  _shutdown() {
    return new Promise((resolve /* ,reject */) => {
      this._unregisterListeners();

      this._pendingIcon.remove();
      this._pendingIcon = undefined;

      this._pausedIcon.remove();
      this._pausedIcon = undefined;

      this._completedIcon.remove();
      this._completedIcon = undefined;

      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
  }

  _registerListeners() {
    this._model.on('ScheduleStatus', (this._onScheduleStatus = this._onScheduleStatus.bind(this)));
  }

  _unregisterListeners() {
    this._model.removeAllListeners('ScheduleStatus');
  }

  /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    this._setScheduleStatus(this._model.getScheduleStatus());
    return Promise.resolve();
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }

  /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

  _onScheduleStatus(newVal) {
    this._setScheduleStatus(newVal);
  }

  /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

  _setScheduleStatus(newVal) {
    this._rootElem.innerHTML = '';
    if (!_.isEmpty(newVal)) {
      switch (newVal) {
        case 'ACTIVE':
          this._rootElem.appendChild(this._pendingIcon);
          break;
        case 'PAUSED':
          this._rootElem.appendChild(this._pausedIcon);
          break;
        case 'COMPLETED':
          this._rootElem.appendChild(this._completedIcon);
          break;
        default:
          this._rootElem.innerHTML = newVal;
      }
    } else {
      this._rootElem.innerHTML = '';
    }
  }

  /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

export default ScheduleStatusRenderer;
